import { styled } from "styled-components";

const MobileBreakpoint = "768px";

export const Container = styled.div`
  font-family: "S-Core Dream", sans-serif;

  flex-grow: 1;
  width: 100%;
  max-width: 1400px; /* ✅ 내용 너비 제한 */
  margin: 0 auto; /* ✅ 가운데 정렬 */
  padding: 20px 16px;
  background-color: transparent;
  border-radius: 0;
  box-shadow: none;
  user-select: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: calc(100vh - 100px);

  @media (max-width: ${MobileBreakpoint}) {
    width: 100%;
    padding: 20px 10px 10px;
    margin-top: 0;
    min-height: auto;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-bottom: 24px;
  position: relative;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 400;
  letter-spacing: -0.3px;
  line-height: 1.5;
  border-bottom: 2px solid #ccc;
  padding-bottom: 4px;
  display: inline-block;

  span + span {
    margin-left: 8px;
  }
`;
export const TitleDot = styled.span`
  font-size: 28px;
  font-weight: 500;
  padding-bottom: 4px;
  margin: 0 2px;
`;
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px; /* ← 년월 사이 간격 */
`;

export const TitlePart = styled.span`
  font-size: 28px;
  font-weight: 500;
  border-bottom: 2px solid #ccc;
  padding-bottom: 4px;
`;

export const NavButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const TodayButton = styled.button`
  position: absolute;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const DayWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-top: none;

  @media (max-width: ${MobileBreakpoint}) {
    width: 100%;
  }
`;

export const CalendarItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 15px;
  color: ${(props) => (props.$isSunday ? "#e53935" : "#444")};
  border-bottom: 1px solid #eee;
  user-select: none;

  @media (max-width: ${MobileBreakpoint}) {
    width: 100%; // 모바일에서 한 칸씩 작게 보이도록
    flex: 1 0 14.2%;
    max-width: 14.2%;
    font-size: 12px;
  }

  .pc-only {
    display: inline;
    margin-bottom: 10px;
  }

  .mobile-only {
    display: none;
  }

  @media (max-width: 768px) {
    .pc-only {
      display: none;
    }

    .mobile-only {
      display: inline;
    }
  }
`;

export const Day = styled.div`
  height: 120px;
  display: flex;
  flex-direction: column; /* 추가 */
  align-items: flex-start; /* 왼쪽 정렬 */
  justify-content: flex-start; /* 위쪽 정렬 */
  padding: 15px 8px 0 15px; /* 패딩 조절 */
  border: 1px solid #f0f0f0;
  font-size: 16px;
  color: #222;
  font-weight: ${(props) => (props.$isSunday ? "bold" : "normal")};
  background-color: ${(props) => (props.$isToday ? "#fff5f5" : "transparent")};
  position: relative;
  user-select: none;

  @media (max-width: ${MobileBreakpoint}) {
    font-size: 12px;
    padding: 4px 0;
    height: auto;
    aspect-ratio: 1 / 1;
  }
`;

export const DayCircle = styled.div`
  background-color: #f8d7da;
  color: #b71c1c;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  font-weight: bold;
  user-select: none;
`;

export const TodayLabel = styled.div`
  font-size: 12px;
  color: #e53935;
  margin-top: 4px;
`;
